
import { useToast } from '@/hooks/use-toast';
import { useQueryClient } from '@tanstack/react-query';

export const useBaseMutation = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  const showSuccessToast = (title: string, description: string) => {
    toast({
      title,
      description,
    });
  };

  const showErrorToast = (title: string, description: string) => {
    toast({
      title,
      description,
      variant: "destructive",
    });
  };

  const invalidateUpdates = () => {
    queryClient.invalidateQueries({ queryKey: ['automated-updates'] });
  };

  return {
    toast,
    queryClient,
    showSuccessToast,
    showErrorToast,
    invalidateUpdates
  };
};
